<template>
  <div class="column" :class="columnSize">
    <b-field
      label="KPI Appeal Status"
      :type="active ? 'is-info' : ''"
      :custom-class="active ? 'has-text-info' : ''"
    />
    <b-field
      v-for="kpiAppealStatus in kpiAppealStatuses"
      :key="kpiAppealStatus.value"
    >
      <b-radio
        :value="value"
        :native-value="kpiAppealStatus.value"
        type="is-dark"
        @input="onInput"
      >
        {{ kpiAppealStatus.label }}
      </b-radio>
    </b-field>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String
    },
    active: {
      type: Boolean,
      default: false
    },
    columnSize: {
      type: Object | String,
      default: "is-12"
    }
  },
  data: () => ({
    kpiAppealStatuses: [
      {
        value: "",
        label: "N/A"
      },
      {
        value: "pending",
        label: "Pending"
      },
      {
        value: "approved",
        label: "Approved"
      },
      {
        value: "rejected",
        label: "Rejected"
      }
    ]
  }),
  methods: {
    onInput(value) {
      this.$emit("input", value);
      this.$emit("update:value", value);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/OrderFilter/Field/OrderFilterFieldKpiAppealStatus.vue